export default "__VITE_ASSET__C24IfFsL__"